import { Path, Svg } from "react-native-svg";
import { getToken } from "@tamagui/core";
import { jsx } from "react/jsx-runtime";
const SvgChevronDown = ({ size = 24, color = "$contentPrimary", ...inProps }) => {
  const outProps = {};
  if (size && (outProps.width = size, outProps.height = size), color) {
    const colorToken = getToken(color, "color");
    outProps.color = colorToken;
  }
  const props = {
    viewBox: "0 0 24 24",
    ...inProps,
    ...outProps
  };
  return /* @__PURE__ */ jsx(Svg, { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...props, children: /* @__PURE__ */ jsx(
    Path,
    {
      fill: "currentColor",
      d: "m11.5 15.713 7.35-7.35q.375-.374.887-.363.513.013.888.388t.375.887-.375.888l-7.7 7.675q-.3.3-.675.45t-.75.15-.75-.15-.675-.45l-7.7-7.7Q2 9.763 2.013 9.263q.012-.5.387-.875t.888-.375.887.375z"
    }
  ) });
};
var ChevronDown_default = SvgChevronDown;
export {
  ChevronDown_default as default
};
